import Select from "react-select";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import {
  emailBodyText,
  getMultiSelectOptions,
  handleMultiSelectChange,
  selectAllSimulations,
  ValidateEmail,
} from "../../../utils/utils";
import { Transition } from "../../../components/Transition";
import auth from "../../../services/auth";
import appService from "../../../services/app.service";
import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import CohortService from "../../../services/CohortService";
import { splitEmailStringIntoBatches } from "../../../utils/utils";
import EmailInvitationBody from "../../../components/EmailInvitationBody";

let linkButtons = "";
const SendSimulationLink = ({
  open,
  handleClose,
  selectedCohort,
  loadDataAfterAssignment,
}) => {
  const [linkParams, setLinkParams] = useState({
    accId: 0,
    emailsList: [],
    mailBody: emailBodyText,
    loading: false,
    loadingMessage: "",
    emailErrorMsg: "",
    simErrorMessage: "",
  });

  const [simulations, setSimulations] = useState([]);
  const [selectedSimulations, setSelectedSimulations] = useState([]);
  const [emailBatches, setEmailBatches] = useState([]);
  const [currentBatchIndex, setCurrentBatchIndex] = useState(0);
  const user = auth.getUserDetails();

  const loadData = async () => {
    setLinkParams((prevState) => ({
      ...prevState,
      accId: user?.accId,
      loading: true,
    }));

    const cohortWithSimualationResponse =
      await CohortService().getCohrotWithAssignedSimulations(
        selectedCohort.value
      );
    setSimulations(cohortWithSimualationResponse?.data?.simulations);
    setLinkParams((prevState) => ({ ...prevState, loading: false }));
  };

  useEffect(() => {
    loadData();
    getCohortParticipantsEmail();
  }, []);

  const getCohortParticipantsEmail = async () => {
    setLinkParams((prevState) => ({ ...prevState, loading: true }));
    try {
      const response = await CohortService().getCohortParticipantsEmail(
        selectedCohort.value
      );
      if (response?.data?.data) {
        const emailBatches = splitEmailStringIntoBatches(
          response?.data?.data,
          50
        );
        setEmailBatches(emailBatches);
        getEmailsList(emailBatches[currentBatchIndex]);
      }
    } catch (error) {
      console.error("Error sending email.", error);
    } finally {
      setLinkParams((prevState) => ({ ...prevState, loading: false }));
    }
  };

  const handleMultiSimulationChange = (value, action) => {
    setLinkParams((prevState) => ({ ...prevState, simErrorMessage: "" }));
    const list = handleMultiSelectChange(
      value,
      action,
      simulations,
      selectedSimulations,
      selectAllSimulations
    );
    setSelectedSimulations(list);
    generateSimsUrl(list);
  };

  const handleEditorChange = (content) => {
    setLinkParams((prevState) => ({ ...prevState, mailBody: content }));
  };

  const createEmailPreview = () => {
    return { __html: linkParams.mailBody + linkButtons };
  };

  const generateSimsUrl = (list) => {
    var usersSims = [];
    if (list !== null && list[0] !== undefined) {
      list.forEach((sim) => {
        var userSim = { simId: sim["value"], simName: sim["label"] };
        usersSims.push(userSim);
      });
    }
    linkButtons =
      "<br> <h5>Click on the link to view the Simulation.</h5> <br>";
    usersSims.forEach((element) => {
      linkButtons +=
        '<a class="sim-link-btn" href="">' + element.simName + "</a><br>";
    });
    setLinkParams((prevState) => ({
      ...prevState,
      mailBody: linkParams.mailBody,
    }));
  };

  const handleEmailChange = (event) => {
    event.preventDefault();
    setLinkParams((prevState) => ({ ...prevState, emailErrorMsg: "" }));
    var emailsData = event.target.value;

    setEmailBatches((prevArray) => {
      const updatedArray = [...prevArray]; // clone the array
      updatedArray[currentBatchIndex] = emailsData; // update the value at the specific index
      return updatedArray;
    });
    getEmailsList(emailsData);
  };

  const getEmailsList = (emailsData) => {
    if (emailsData != null) {
      let mailList = emailsData
        .split(/[\n,;]+/)
        .filter(Boolean)
        .map((e) => e.trim());

      if (mailList.length > 50) {
        setLinkParams((prevState) => ({
          ...prevState,
          hasEmailError: true,
          emailErrorMsg:
            "The maximum email limit is 50. If your email count exceeds this limit, Please select up to 50 emails and send the remaining emails in the next batch.",
        }));
      } else {
        const invalidEmail = mailList.find((email) => !ValidateEmail(email));

        if (invalidEmail) {
          setLinkParams((prevState) => ({
            ...prevState,
            hasEmailError: true,
            emailErrorMsg:
              "Please enter valid email addresses separated by comma or semicolon.",
          }));
          return;
        }

        setLinkParams((prevState) => ({
          ...prevState,
          emailsList: mailList,
        }));
      }
    }
  };

  const sendLinks = async (e) => {
    if (selectedSimulations.length === 0) {
      setLinkParams((prevState) => ({
        ...prevState,
        simErrorMessage: "Please select simulations.",
      }));
      return;
    }
    if (linkParams.emailsList.length === 0) {
      setLinkParams((prevState) => ({
        ...prevState,
        emailErrorMsg: "Please enter emails.",
      }));
      return;
    }
    e.preventDefault();
    const data = {
      usageType: "Asynchronous",
      simulations: selectedSimulations,
      accId: linkParams.accId,
      emailsList: Array.from(new Set(linkParams['emailsList'])),
      cohorts: [{ id: selectedCohort.value }],
      mailBody: linkParams.mailBody,
    };
    setLinkParams((prevState) => ({
      ...prevState,
      loading: true,
      loadingMessage: `Email sending for Batch ${
        currentBatchIndex + 1
      } is in progress !`,
    }));
    const sims = await appService.submit(data, "sims/generateUrls");
    if (sims.status === 200) {
      setLinkParams((prevState) => ({
        ...prevState,
        loading: false,
        loadingMessage: "",
      }));

      const nextIndex = currentBatchIndex + 1;
      if (nextIndex < emailBatches.length) {
        setCurrentBatchIndex(nextIndex);
        getEmailsList(emailBatches[nextIndex]);
      } else {
        loadDataAfterAssignment();
        handleClose();
      }
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      maxWidth="md"
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Send Simulation Link</DialogTitle>
      <DialogContent>
        <form className="form-horizontal" noValidate={true}>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label content-body">
              Type
            </label>
            <div className="col-sm-9">
              <input
                name="name"
                type="text"
                defaultValue="Asynchronous SIM"
                className="form-control form-control-success fields-font"
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label content-body">
              Cohort
            </label>
            <div className="col-sm-9">
              <input
                name="name"
                type="text"
                defaultValue={selectedCohort.label}
                className="form-control form-control-success fields-font"
                readOnly={true}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label required content-body">
              Select Simulations
            </label>
            <div className="col-sm-9">
              <Select
                name="simulations"
                className="basic-multi-select fields-font"
                isMulti={true}
                options={getMultiSelectOptions(
                  simulations,
                  selectedSimulations,
                  selectAllSimulations
                )}
                onChange={handleMultiSimulationChange}
                value={selectedSimulations}
              />
              {linkParams.simErrorMessage != "" && (
                <span className="error">{linkParams.simErrorMessage}</span>
              )}
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-3 form-control-label required label">
              Email Addresses
            </label>
            <div className="col-sm-9">
              <textarea
                name="emails"
                rows={5}
                id="emails"
                placeholder="Emails"
                className="form-control form-control-success fields-font"
                onChange={handleEmailChange}
                value={emailBatches[currentBatchIndex] || ""}
              />
              {linkParams.emailErrorMsg != "" && (
                <span className="error">{linkParams.emailErrorMsg}</span>
              )}
            </div>
          </div>

          <EmailInvitationBody
            emailBody={linkParams.mailBody}
            handleEditorChange={handleEditorChange}
          />

          <div className="form-group row">
            <div className="col-sm-9 offset-sm-3">
              <button
                type="button"
                onClick={sendLinks}
                className="btn btn-submit float-right buttons"
                disabled={
                  selectedSimulations.length === 0 ||
                  linkParams.emailsList?.length === 0 ||
                  currentBatchIndex >= emailBatches.length
                }
              >
                Send
              </button>
              <button
                type="button"
                className="btn btn-cancel float-right buttons"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>

            <div className="col-sm-9 offset-sm-3">
              <hr></hr>
              <h4 className="sub-heading">Preview Before You Send!</h4>
              <div
                className="mail-preview-container"
                dangerouslySetInnerHTML={createEmailPreview()}
              />
            </div>
          </div>
        </form>
      </DialogContent>
      {linkParams.loading && (
        <div className="overlay">
          <Loader
            loading={linkParams.loading}
            loadingMessage={linkParams.loadingMessage}
          />
        </div>
      )}
    </Dialog>
  );
};

export default SendSimulationLink;
